/* Vue 3 Version */
// TODO: Need to check this works 100% correctly..

const LifetimeIframeControl = {
  install(Vue, options) {
    //console.log(options) // Only enable this if debugging
    const clientConfig = options.clientConfig.settings;
    Vue.lastHeight = 0;

    if (typeof clientConfig.disableIframePostMessage == 'undefined') {
      Vue.disableIframePostMessage = false;
    } else {
      Vue.disableIframePostMessage = clientConfig.disableIframePostMessage;
    }

    try { // iFrame Detection code
      Vue.isInIframe = window.self != window.top;
    }
    catch(e) {
      Vue.isInIframe = true;
    }

    //try { // Alternate iFrame Detection code
    //	window.top._top = true;
    //	Vue.isInIframe = !window._top;
    //} catch(e) {
    //	Vue.isInIframe = true;
    //}

    if (!Vue.isInIframe) {
      Vue.disableIframePostMessage = true;
    }

    Vue.config.globalProperties.$refreshIframeHeight = function() {
      if (!Vue.disableIframePostMessage) {
        var currentHeight = parseFloat(getComputedStyle(document.getElementById(options.divId), null).height.replace("px", ""));
        if (this.lastHeight != currentHeight) {
          //console.log('Triggering Resize', currentHeight);
          parent.postMessage({"type": 'resize', "height": currentHeight}, "*");
          Vue.lastHeight = currentHeight;
        }
      }
    }

    Vue.config.globalProperties.$scrollIframeTop = function() {
      if (!Vue.disableIframePostMessage) {
        //console.log('Triggering Scroll');
        parent.postMessage({"type": 'scrolltop', "behavior": 'smooth'}, "*");
      }
    }
  }
};

export default LifetimeIframeControl
// this.$refreshIframeHeight();
// this.$scrollIframeTop();
